import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { auto } from '@popperjs/core';
export default theme => ({
  root: {
    boxSizing: 'border-box',
    padding: '0px 16px 16px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  chat: _objectSpread(_objectSpread({
    flex: 1,
    overflowX: 'hidden',
    boxSizing: 'border-box',
    borderRadius: 6
  }, theme.utils.scrollbar), {}, {
    '& .dana-chat-conversation': {
      width: '100%'
    },
    '& [class*="CopilotChat__root"]': {
      marginTop: 0
    }
  }),
  input: {
    marginTop: auto
  }
});